import { useState, useEffect, useRef, useMemo } from "react";
import {
  useParams,
  useLocation,
  Link,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import exportFromJSON from "export-from-json";
import axios from "axios";

import PublishIcon from "@material-ui/icons/Publish";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import SystemUpdateAltOutlinedIcon from "@material-ui/icons/SystemUpdateAltOutlined";
import GridViewIcon from "@material-ui/icons/Dashboard";
import { Line } from "../../../../Dashboard/Dashboard.style";
import { ChapterContainer } from "../../Boards.style";
import { BoardsHeader, ButtonWrapper, Button } from "../../Boards.style";
import {
  DashboardHeaderWrapper,
  DashboardHeader,
} from "../../../../Dashboard/Dashboard.style";
import HeaderPage from "../../../../Header/HeaderPage";
import CommonComponent from "../../../../CommonComponent/CommonComponent";
import InputComponent from "../../../../Input/InputComponent";
import DocumentLoading from "../../../../Loading/ExportLoader";
import UploadAssessmentComponent from "../../../../Modal/UploadAssessment";
import CreateAssessmentComponent from "../../../../Modal/CreateAssessmentComponent";
import ExportModal from "../../../../Modal/ExportModal";
import ExportQuestionModal from "../../../../Modal/ExportQuestionModal";
import ImportModal from "../../../../Modal/ImportModal";
import CopyContentModal from "../../../../Modal/CopyContentModal";
import ModuleUploadModal from "../../../../Modal/Module-v2/ModuleUploadModal";
import AddModules from "../../../../Modal/AddModules";
import { useAuth } from "../../../../../Auth/Auth";
import AddModalComponent from "../../../../Modal/AddModalComponent";
import { ModuleSearch } from "../../../ModuleSearch";
import CompetencyQuestions from "../../../../Questions/CompetencyQuestions/CompetencyQuestions";
import { sortModule } from "../../../../../utils/sortModule";
import {
  chapter,
  CompetencyQuestion,
  Module,
  Question,
  Topics,
} from "../../../../../Api/api";
import { addTopic } from "../../../../RenderDetailsData/RenderDetailsData";
import ProfileImg from "../../../../../images/profileImg.svg";
import ArrangerBoard from "../../../../Modal/CardArranger";

const editModule = [
  [
    {
      label: "MODULE",
      placeholder: "Enter Module Name",
      width: "100%",
      name: "name",
    },
  ],
];
const TopicLabel = [
  [
    {
      label: "TOPIC",
      placeholder: "Enter Topic",
      width: "100%",
      name: "name",
    },
  ],
  [
    {
      label: "THUMBNAIL",
      placeholder: "Enter an url",
      width: "100%",
      name: "thumbnail",
    },
  ],
];

const fixName = (name) => {
  const charArrays = ["?", "+", "/"];
  charArrays.forEach((character) => {
    name = name.replaceAll(character, "");
  });
  return name;
};

function Chapters() {
  const navigation = useNavigate();
  const [page, setPage] = useState("module"); //module | objective | assessment
  const [modal, setModal] = useState(false);
  const [exportModal, setExportModal] = useState(false);
  const [exportQuestionModal, setExportQuestionModal] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [copyContentModal, setCopyModal] = useState(false);
  const [moduleUploadModal, setModuleUploadModule] = useState(false);
  const [type, setType] = useState("");
  const [topics, setTopics] = useState([]);
  const [allModule, setAllModule] = useState([]);
  const [filterModule, setFilterModule] = useState([]);
  const [rendr, setRndr] = useState(false);
  const query = useLocation().search;
  const [questionUploading, setQuestionUploading] = useState(false);
  const trial = new URLSearchParams(query).get("trial");
  const { readCookie, DisplaySnackbar } = useAuth();
  const [headerText, setHeaderText] = useState("");
  const { state } = useLocation();
  const [activeId, setActiveId] = useState("");
  const [editId, setEditId] = useState("");
  const [edit, setEdit] = useState(false);
  const [render, setRender] = useState(false);
  const [loading, setLoading] = useState(false);
  const [competencyLoading, setCompetencyLoading] = useState(false);

  const [formData, setFormData] = useState({
    disabled: true,
    lang: "",
    modules: [],
    name: "",
    thumbnail: "",
    totalModules: 1,
    trial: true,
    _id: "",
  });
  const {
    id,
    classId,
    chapterId,
    subjectId,
    countryName,
    subjectName,
    chapterName,
    boardName,
    className,
    boardId,
  } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const [topicQuestion, setQuestion] = useState([]);
  const [competencyQuestions, setCompetencyQuestions] = useState([]);
  const [search, setSearch] = useState("");
  const [arrangeModal, setArrangeModal] = useState(false);

  const leftHeader = () => {
    return (
      <div>
        <span>Courses</span> {` > `}
        <Link style={{ textDecoration: "none", color: "black" }} to="/courses">
          {" "}
          <span>{countryName}</span>
        </Link>{" "}
        {` > `}
        <span
          onClick={() => sendBack("board")}
          style={{ textDecoration: "none", color: "black", cursor: "pointer" }}
        >
          {boardName}
        </span>
        {` > `}
        <span
          onClick={() => sendBack("board")}
          style={{ textDecoration: "none", color: "black", curosr: "pointer" }}
        >
          {className}
        </span>
        {` > `}
        <span
          onClick={() => sendBack("subject")}
          style={{ textDecoration: "none", color: "black", cursor: "pointer" }}
        >
          {subjectName}
        </span>{" "}
        {` > `}
        <span
          onClick={() => sendBack("subject")}
          style={{ textDecoration: "none", color: "black", cursor: "pointer" }}
        >
          {chapterName}
        </span>
        {` > `}
        <span>Topics</span>
      </div>
    );
  };

  const language = useMemo(
    () => searchParams.get("language") || "english",
    [searchParams]
  );

  const handleOnClick = (modulesId) => {
    let _topic = topics.find((item) => item._id === activeId);
    let TopicName = _topic?.name || "";
    let TopicId = _topic?._id || "";
    navigation(
      `/courses/${fixName(countryName)}/${id}/${fixName(
        boardName
      )}/${boardId}/${fixName(className)}/${classId}/${fixName(
        subjectName
      )}/${subjectId}/${fixName(chapterName)}/${chapterId}/${fixName(
        TopicName
      )}/${TopicId}/modules/${modulesId}?language=${language}`,
      {
        state: {
          topicId: activeId,
        },
      }
    );
  };

  const sendBack = (type) => {
    if (type === "board") {
      navigation(
        `/courses/${fixName(
          countryName
        )}/${id}?board=${boardId}&language=${language}`,
        {
          state: {
            boardID: boardId,
          },
        }
      );
    } else {
      navigation(
        `/courses/${fixName(countryName)}/${id}/${fixName(
          boardName
        )}/${boardId}/${fixName(
          className
        )}/${classId}?subject=${subjectId}&language=${language}`
      );
    }
  };

  const handleCreateTopic = () => {
    axios
      .post(
        Topics.addTopics,
        {
          name: formData.name,
          lang: language,
          thumbnail: formData.thumbnail,
          chapterId: chapterId,
          trial,
          priority: topics.length,
        },
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        if (topics.length === 0) {
          setRndr(!rendr);
        }
        setTopics([...topics, res.data.data.topic]);

        DisplaySnackbar("Topic Added", "success");

        setModal(false);
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };
  const EditTopic = () => {
    if (!formData.name) {
      DisplaySnackbar("Add Topic Name First", "error");
      return;
    }
    axios
      .patch(
        Topics.EditTopic(formData._id),
        {
          name: formData.name,
          lang: language,
          thumbnail: formData.thumbnail,
          chapterId: chapterId,
          trial,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        setTopics(
          topics.map((item) =>
            item._id === formData?._id
              ? {
                  ...item,
                  name: formData.name,
                  lang: language,
                  thumbnail: formData.thumbnail,
                  trial,
                }
              : item
          )
        );
        setModal(false);
        DisplaySnackbar("Edit Topic SuccessFull", "success");
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };

  const handleEdit = (moduleId) => {
    setEdit(true);
    setEditId(moduleId);
    const moduleToEdit = allModule.find((item) => `${item._id}` === moduleId);
    setFormData(moduleToEdit || {});
  };

  const handleEditModule = () => {
    if (!formData.name) {
      DisplaySnackbar("Enter Module Name", "error");
      return;
    }
    axios
      .patch(
        Module.updateModules(editId),
        {
          name: formData.name,
        },
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        setAllModule(
          allModule.map((item) =>
            item._id === editId ? { ...item, name: formData.name } : item
          )
        );
        setFilterModule(
          filterModule.map((item) =>
            item._id === editId ? { ...item, name: formData.name } : item
          )
        );

        setEdit(false);
        DisplaySnackbar("Module Edited", "success");
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };
  const handleCreate = () => {
    if (edit) {
      handleEditModule();
    } else if (headerText === "Add Topics") {
      handleCreateTopic();
    } else if (headerText === "Edit Topics") {
      EditTopic(id);
    }
  };
  const handleCreateAssessment = async (field) => {
    const {
      question,
      questionType,
      assertion,
      reasoning,
      options,
      cognitive,
      difficulty,
      correctAnswers,
      quesImg,
      assertImg,
      reasonImg,
      optionsFile,
    } = field;

    let form = new FormData();

    form.append("subjectId", subjectId);
    form.append("chapterId", chapterId);
    form.append("topicId", activeId);

    [
      { img: quesImg, name: "questionImg" },
      { img: assertImg, name: "assertImg" },
      { img: reasonImg, name: "reasonImg" },
    ].forEach((data) => {
      form.append(data.name, data.img);
    });

    for (let i = 0; i < optionsFile.length; i++) {
      form.append(`op${i + 1}`, optionsFile[i].value);
    }

    form.append(
      "question",
      JSON.stringify({
        question,
        questionType,
        description: {
          assertion,
          reasoning,
        },
        options,
        cognitive,
        difficulty,
        correctAnswers,
        visibilityStatus: "publicForAll",
      })
    );

    await axios
      .post(Question.addQuestion, form, {
        headers: { token: `${readCookie("token")}` },
        validateStatus: () => true,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.status !== "success") {
          throw res;
        }
        setQuestion([{ ...res.data.data.question }, ...topicQuestion]);
        setModal(false);
        DisplaySnackbar("Question Created", "success");
      })
      .catch((err) => {
        // console.log(err);
        DisplaySnackbar(err.data.message, "error");
      });
  };

  const fetchCompetencyQuestions = async (chapterId) => {
    if (competencyLoading) return;
    setCompetencyLoading(true);
    await axios
      .get(CompetencyQuestion.getQuestions(chapterId), {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        setCompetencyQuestions(res.data.data.questions);
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setCompetencyLoading(false);
      });
  };

  const fetchQuestions = async (topicId) => {
    axios
      .get(Question.getQuestions(topicId), {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        setQuestion(res.data.data.questions);
      })
      .catch((err) => console.log(err));
  };

  const handleUpdateQuestion = async (id, data, cb) => {
    await axios
      .patch(Question.editQuestion(id), data, {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        cb();
        setQuestion(
          topicQuestion.map((que) =>
            que._id === id ? { ...res.data.data.question } : que
          )
        );
        DisplaySnackbar("Question Updated", "success");
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };
  const ToogleDisable = (id, disable) => {
    axios
      .patch(
        Module.toogleDisableModule(id),
        {
          disabled: !disable,
        },
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "success") {
          setAllModule(
            allModule.map((item) =>
              item._id === id ? { ...item, disabled: !disable } : item
            )
          );
          setFilterModule(
            filterModule.map((item) =>
              item._id === id ? { ...item, disabled: !disable } : item
            )
          );
          DisplaySnackbar(
            `Module has been  ${disable ? "Enabled" : "Disabled"}`,
            "success"
          );
        }
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };
  const handleDeleteQuestion = (id) => {
    axios
      .delete(Question.deleteQuestion(id), {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        setQuestion(topicQuestion.filter((item) => item._id !== id));
        // alert("Deleted Sucessfully");
        DisplaySnackbar("Deleted Successfully", "success");
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };
  // console.log(allModule);
  const handleUploadAssessment = async (quest) => {
    setModal(false);
    setQuestionUploading(true);
    await axios
      .post(
        Question.UploadQuestions,
        {
          subjectId: subjectId,
          chapterId: chapterId,
          topicId: activeId,
          questions: quest,
        },
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        setModal(false);
        // setQuestion([...topicQuestion, ...quest]);
        setRender(!render);
        if (res?.data?.errors?.errorLogs?.length) {
          let data = res?.data?.errors?.errorLogs.map((item) => {
            return {
              row: item?.row,
              error: item?.error,
            };
          });

          const fileName = "Error_Logs";
          const exportType = exportFromJSON.types.csv;
          exportFromJSON({ data, fileName, exportType });
        }
        DisplaySnackbar(
          `Question Inserted = ${res.data?.errors?.inserted} and Question Skipped= ${res?.data?.errors?.skipped} out of Total Question=${res?.data?.errors?.totalQuestions} `,
          "info",
          10000000
        );
      })
      .catch((err) => {
        if (err.response) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
    setQuestionUploading(false);
  };

  const fetchTopics = async (id) => {
    await axios
      .get(Module.getModuleByTopics(id), {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        const filteredModules = res.data.data.topic.modules.filter(
          (item) => item.lang === language
        );

        if (filteredModules.length) {
          const sortedModules = sortModule(filteredModules);
          setAllModule(sortedModules);
          setFilterModule(sortedModules);
        } else {
          setAllModule([]);
          setFilterModule([]);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };

  const onTopicChange = async (id) => {
    setSearchParams({ topic: id, language });
  };

  useEffect(() => {
    //Fetch chapter topics
    axios
      .get(chapter.getTopicsByChapter(chapterId), {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then(async (res) => {
        let data = res.data.data.chapter.topics
          .filter((item, i ) => {
            return (
              item.lang === language && (item.trial || false) === (state?.trial || false)
            );
          })
          .sort((t1, t2) => t1.priority - t2.priority);

        setTopics(data);
      })
      .catch((err) => {
        console.log(err);
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  }, [rendr]);

  useEffect(() => {
    if (!topics.length) return;
    const id = searchParams.get("topic") || topics[0]?._id;
    if (id === activeId) return;
    setActiveId(id);
  }, [topics, searchParams]);

  useEffect(() => {
    if (!activeId || loading) return;
    (async () => {
      setLoading(true);
      await fetchTopics(activeId);
      await fetchQuestions(activeId);
      setLoading(false);
    })();
  }, [activeId]);

  useEffect(() => {
    fetchCompetencyQuestions(chapterId);
  }, []);

  const handleDeleteTopic = (id) => {
    axios
      .delete(Topics.deleteTopic(id), {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          DisplaySnackbar("Topic deleted", "success");
          handleupdateDeleteTopiclist(id);
        }
      })
      .catch((err) => {
        DisplaySnackbar(err?.response?.data?.message, "error");
      });
  };

  const handleDisableTopic = (id, disable) => {
    axios
      .patch(
        Topics.toogleDisableTopic(id),
        {
          disabled: !disable,
        },
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "success") {
          const topicIndex = topics.findIndex((topic) => `${topic._id}` === id);
          topics[topicIndex].disabled = !disable;
          setTopics([...topics]);
          DisplaySnackbar(
            `Topic has been  ${disable ? "Enabled" : "Disabled"}`,
            "success"
          );
        }
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };

  const handleupdateDeleteTopiclist = (id) => {
    const filteredData = topics.filter((i) => i._id !== id);
    setTopics(filteredData);
  };

  const handleDeleteModule = (id) => {
    axios
      .delete(Module.deleteModule(id), {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          DisplaySnackbar("Module deleted", "success");
          handleupdateDeleteModulelist(id);
        }
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };

  const updatePriority = async (id, list) => {
    const API_URL = id === "modules" ? Module.priority : Topics.priority;
    if (!API_URL) return;
    axios
      .put(
        API_URL,
        { list },
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "success") {
          //DisplaySnackbar("Module", "success");
        }
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };

  const handleupdateDeleteModulelist = (id) => {
    const filteredData = allModule.filter((i) => i._id !== id);
    setAllModule([...filteredData]);
  };

  const handleEdittopic = (id) => {
    const topicToEdit = topics.find((item) => item._id === id);
    setEditId(id);
    setHeaderText("Edit Topics");
    setModal(true);
    setFormData(topicToEdit || {});
    setType("TOPIC");
  };

  const EditModule = (id) => {
    const moduleToEdit = allModule.find((item) => `${item._id}` === id);
    setEditId(id);
    setHeaderText("Edit Module");
    setModal(true);
    setFormData(moduleToEdit || {});
    setType("MODULE");
  };

  const saveList = async (priorityList, arrangedData) => {
    await updatePriority(arrangedData.id, priorityList);
    if (arrangedData.id === "modules") {
      setAllModule([...arrangedData.items]);
    } else {
      setTopics([...arrangedData.items]);
    }
  };

  return (
    <ChapterContainer>
      <DashboardHeaderWrapper minHeight="90px">
        <DashboardHeader>
          <div>
            <h1>Courses</h1>
          </div>

          <div>
            {page === "module" ? <ModuleSearch /> : null}
            {page === "objective" ? (
              <InputComponent
                val={search}
                setVal={setSearch}
                type="text"
                search
                placeholder="Search..."
              />
            ) : null}
            <Link to="/profile">
              <img
                style={{
                  maxWidth: "100px",
                  height: "50px",
                  borderRadius: "50%",
                }}
                src={localStorage.getItem("imgUrl") || ProfileImg}
                alt="profileimg"
              />
            </Link>
          </div>
        </DashboardHeader>
        <DashboardHeader></DashboardHeader>
        <HeaderPage
          close={false}
          leftHeader={leftHeader(
            countryName,
            boardName,
            className,
            subjectName,
            chapterName,
            id,
            classId,
            chapterId,
            subjectId
          )}
        />
      </DashboardHeaderWrapper>
      <Line />
      <BoardsHeader>
        <div
          className={`firstClass ${page !== "module" && "assessment"}`}
          style={{ flex: 1, justifyContent: "start" }}
        >
          {page !== "competency" ? (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                setModal(true);
                setType("TOPIC");
                setHeaderText("Add Topics");
              }}
              className="child iconContainer"
            >
              {" "}
              <AddBoxOutlinedIcon className="icon" /> Add Topics
            </div>
          ) : null}
          {/*<div
            onClick={() => {
              setModal(true);
              setType("");
              setHeaderText(
                page === "module" ? "Add Modules" : "Create Assessment"
              );
            }}
            style={{ cursor: "pointer" }}
            className="child iconContainer"
          >
            <AddBoxOutlinedIcon className="icon" />{" "}
            {page === "module" ? "Add Modules" : "Create Assessment"}
          </div>*/}
          {page === "module" ? (
            <>
              <div
                onClick={() => {
                  setModuleUploadModule(true);
                  setType("");
                  setHeaderText("Add Module");
                }}
                style={{ cursor: "pointer" }}
                className="child iconContainer"
              >
                <AddBoxOutlinedIcon className="icon" /> Add Module
              </div>
              <div
                onClick={() => {
                  setCopyModal(true);
                  setType("");
                  setHeaderText("Copy Module");
                }}
                style={{ cursor: "pointer" }}
                className="child iconContainer"
              >
                <AddBoxOutlinedIcon className="icon" /> Copy Module
              </div>
              <div
                onClick={() => {
                  setArrangeModal(true);
                }}
                style={{ cursor: "pointer" }}
                className="child iconContainer"
              >
                <GridViewIcon className="icon" /> Arrange
              </div>
            </>
          ) : (
            <>
              <div
                onClick={() => {
                  setModal(true);
                  setType("");
                  setHeaderText("Create Assessment");
                }}
                style={{ cursor: "pointer" }}
                className="child iconContainer"
              >
                <AddBoxOutlinedIcon className="icon" /> {"Create Assessment"}
              </div>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setModal(true);
                  setType("assessment");
                  setHeaderText("Upload Assessment");
                }}
                className="child iconContainer"
              >
                <PublishIcon className="icon" /> Upload Assessment
              </div>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => setExportQuestionModal(true)}
                className="child iconContainer"
              >
                <SystemUpdateAltOutlinedIcon
                  className="icon"
                  style={{ transform: "rotate(180deg)" }}
                />{" "}
                Export Assessment
              </div>
            </>
          )}
        </div>
        <div style={{ justifyContent: "flex-end" }} className="secondClass">
          {page === "module" ? (
            <>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => setImportModal(true)}
                className="child iconContainer"
              >
                <SystemUpdateAltOutlinedIcon
                  className="icon"
                  style={{ transform: "rotate(180deg)" }}
                />{" "}
                Import
              </div>

              <div
                style={{ cursor: "pointer", marginRight: "20px" }}
                onClick={() => setExportModal(true)}
                className="child iconContainer"
              >
                <SystemUpdateAltOutlinedIcon className="icon" /> Export
              </div>
            </>
          ) : null}
          <div className="child">
            <ButtonWrapper>
              <Button
                onClick={() => {
                  setPage("module");
                }}
                first
                active={page === "module"}
              >
                Module
              </Button>
              <Button
                onClick={() => {
                  setPage("objective");
                }}
                second
                active={page === "objective"}
              >
                Objective
              </Button>
              <Button
                onClick={() => {
                  setPage("competency");
                }}
                first
                active={page === "competency"}
              >
                Competency
              </Button>
            </ButtonWrapper>
          </div>
        </div>
      </BoardsHeader>
      <Line />
      {page === "competency" ? (
        <CompetencyQuestions
          subjectId={subjectId}
          chapterId={chapterId}
          headerText={headerText}
          loading={competencyLoading}
          modal={modal}
          setModal={setModal}
          exportQuestionModal={exportQuestionModal}
          setExportQuestionModal={setExportQuestionModal}
          sources={[
            {
              name: chapterName,
              path: `${countryName} > ${boardName} > ${className} > ${subjectName} > ${chapterName}`,
              api: `competency-questions?chapterId=${chapterId}`,
            },
          ]}
          questions={competencyQuestions}
          setQuestion={setCompetencyQuestions}
          filterBy={search}
        />
      ) : (
        <>
          <CommonComponent
            loading={loading}
            onTabChange={onTopicChange}
            module={page === "module"}
            handleOnClick={handleOnClick}
            type="Modules"
            filterBy={search}
            tab={topics}
            showDisable={true}
            ToogleDisable={ToogleDisable}
            handleEdit={handleEdit}
            tabContent={allModule}
            assessment={page !== "module"}
            topicId={activeId}
            tabActive={activeId}
            topicQuestion={topicQuestion}
            setQuestion={setQuestion}
            render={render}
            isBoard={false}
            isTopic={true}
            setType={setType}
            isModule={true}
            handleEdittopic={handleEdittopic}
            handleDeleteTopic={handleDeleteTopic}
            handleDisableTopic={handleDisableTopic}
            handleDeleteModule={handleDeleteModule}
            handleUpdateQuestion={handleUpdateQuestion}
            handleDeleteQuestion={handleDeleteQuestion}
            EditModule={EditModule}
          />
          {edit && (
            <AddModalComponent
              buttonText={"Edit"}
              formData={formData}
              setFormData={setFormData}
              setModal={setEdit}
              label={type === "TOPIC" ? TopicLabel : editModule}
              headerText="Edit Module"
              handleEditModule={handleEditModule}
              modalType={type === "TOPIC" ? "TOPIC" : "MODULE"}
            />
          )}
          {modal &&
            (headerText === "Add Topics" ? (
              <AddModalComponent
                headerText={headerText}
                formData={formData}
                setFormData={setFormData}
                handleCreate={handleCreate}
                label={addTopic}
                setModal={setModal}
              />
            ) : headerText === "Add Modules" ? (
              <AddModules
                allModule={allModule}
                setAllModule={setAllModule}
                activeId={activeId}
                setModal={setModal}
                lang={language}
              />
            ) : headerText === "Create Assessment" ? (
              <CreateAssessmentComponent
                handleCreateAssessment={handleCreateAssessment}
                setModal={setModal}
                no={topicQuestion.length + 1}
              />
            ) : headerText === "Edit Topics" ? (
              <AddModalComponent
                headerText={headerText}
                formData={formData}
                setFormData={setFormData}
                handleCreate={handleCreate}
                label={addTopic}
                setModal={setModal}
                buttonText={headerText === "Edit Topics" ? "Edit" : "Create"}
                modalType={type == "TOPIC" ? "TOPIC" : "TOPIC"}
                EditTopic={EditTopic}
              />
            ) : (
              <UploadAssessmentComponent
                handleUploadAssessment={handleUploadAssessment}
                setModal={setModal}
              />
            ))}
          {questionUploading && (
            <DocumentLoading text="Please Wait we are uploading your questions" />
          )}
          {exportModal && (
            <ExportModal
              setModal={setExportModal}
              sources={[
                {
                  name: chapterName,
                  api: `/chapter-contents/${chapterId}?lang=${language}`,
                  filename: `${countryName}-${boardName}-${className}-${subjectName}`,
                },
                {
                  name: topics.find((item) => `${item._id}` === activeId)?.name,
                  api: `/topic-contents/${activeId}?lang=${language}`,
                  filename: `${countryName}-${boardName}-${className}-${subjectName}-${chapterName}`,
                },
              ]}
            />
          )}
          {importModal && (
            <ImportModal
              setModal={setImportModal}
              sources={[
                {
                  name: chapterName,
                  path: `${countryName} > ${boardName} > ${className} > ${subjectName} > ${chapterName}`,
                  api: `/chapter-contents/${chapterId}`,
                },
                {
                  name: topics.find((item) => `${item._id}` === activeId)?.name,
                  path: `${countryName} > ${boardName} > ${className} > ${subjectName} > ${chapterName}`,
                  api: `/topic-contents/${activeId}`,
                },
              ]}
            />
          )}
          {exportQuestionModal && (
            <ExportQuestionModal
              setModal={setExportQuestionModal}
              sources={[
                {
                  name: chapterName,
                  path: `${countryName} > ${boardName} > ${className} > ${subjectName} > ${chapterName}`,
                  api: `questions?chapterId=${chapterId}`,
                },
                {
                  name: topics.find((item) => `${item._id}` === activeId)?.name,
                  path: `${countryName} > ${boardName} > ${className} > ${subjectName} > ${chapterName}`,
                  api: `questions?topicId=${activeId}`,
                },
              ]}
            />
          )}
          {copyContentModal && (
            <CopyContentModal
              setModal={setCopyModal}
              destination={{
                id: activeId,
                name: topics.find((item) => `${item._id}` === activeId)?.name,
                api: `/copy-module`,
                setContent: (module) => {
                  if (!module) return;
                  setAllModule([...allModule, module]);
                },
              }}
            />
          )}
          {moduleUploadModal && (
            <ModuleUploadModal
              allModule={allModule}
              setAllModule={setAllModule}
              activeId={activeId}
              setModal={setModuleUploadModule}
              lang={language}
            />
          )}
        </>
      )}

      {arrangeModal && (
        <ArrangerBoard
          title={"Arrange Modules"}
          data={[
            {
              id: "topics",
              title: "Topics",
              items: topics,
            },
            {
              id: "modules",
              title: "Modules",
              items: allModule,
            },
          ]}
          saveList={saveList}
          setModal={setArrangeModal}
        />
      )}
    </ChapterContainer>
  );
}

export default Chapters;
